// extracted by mini-css-extract-plugin
export default {"theme-container":"List_theme-container__ytGk2","list":"List_list__xzJPZ","link":"List_link__zMoF5"};